import { AlertCircle } from "lucide-react";

export function InlineError({ message, title = "Une erreur est survenue", className = "" }) {
  if (!message) return null;
  return (
    <div className={`alert-error ${className}`} data-testid="inline-form-error" role="alert">
      <AlertCircle className="w-5 h-5 shrink-0 mt-0.5 text-[#DC2626]" />
      <div className="min-w-0">
        <p className="font-semibold">{title}</p>
        <p className="text-xs mt-0.5 text-[#B91C1C] break-words">{message}</p>
      </div>
    </div>
  );
}
